// Modules:
import React from 'react';

// Material UI:
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

const CountySelector = ({
    counties,
    handleDropdownSelect,
    selection,
    styles,
}) => (
    <Grid container justify="center">
        <FormControl sx={styles}>
            <Select
                variant="standard"
                id="county-select"
                value={selection}
                onChange={handleDropdownSelect}
            >
                {counties.map((county) => (
                    <MenuItem key={county.code} value={county.code}>
                        {county.county}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText id="select-by-county-text">
                Select County
            </FormHelperText>
        </FormControl>
    </Grid>
);
export default CountySelector;
